export default __webpack_public_path__ + "static/media/logo.c5b36573.png";